import AccessTimeIcon from '@mui/icons-material/AccessTime';
import type { IMyTimeSummary } from '@pulse/shared';
import { alpha, Box, LinearProgress, Paper, Stack, Typography, useTheme } from '@pulse/ui';

// Lives in the right rail next to the weekly bar chart — was previously the 4th KPI card, moved
// out so the top row can hold Compliance/Overdue/Due Today/Expedited as a uniform set.
export function HoursLoggedCard({ timeSummary }: { timeSummary?: IMyTimeSummary }) {
  const theme = useTheme();
  const hoursLogged = (timeSummary?.days ?? []).reduce((sum, d) => sum + d.hours, 0);
  const weekTarget = timeSummary?.weekTargetHours ?? 40;
  const hoursPct = weekTarget > 0 ? Math.min(100, (hoursLogged / weekTarget) * 100) : 0;

  return (
    <Paper sx={{ p: 2, borderRadius: 3 }}>
      <Stack spacing={1}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box sx={{ width: 44, height: 44, borderRadius: 2, bgcolor: alpha(theme.palette.secondary.main, 0.1), display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <AccessTimeIcon sx={{ color: 'secondary.main' }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h4" fontWeight={900} color="primary.main" lineHeight={1}>
              {hoursLogged}
              <Typography component="span" variant="body2" color="text.secondary"> hrs logged this week</Typography>
            </Typography>
          </Box>
        </Stack>
        <LinearProgress variant="determinate" value={hoursPct} color="secondary" sx={{ height: 6, borderRadius: 3 }} />
      </Stack>
    </Paper>
  );
}
